import { adminHttpClient } from '../commons/adminHttpClient'
import OrderedPageFilter from '../commons/orderedPageFilter'
import PagedList from '../commons/pagedList'
import { ExpenseTypeEligibility } from '../../domain/expenses/expenseTypeEligibility'

export interface PagedExpenses extends PagedList<Expense> {}

export interface Expense {
  id: string
  name: string
  eligibilityType: ExpenseTypeEligibility
  isPremium: boolean
  code: string
  limitedHraEligible: boolean
  isSpousePremium: boolean
}

export interface ExpenseTypeFilter extends OrderedPageFilter {
  planPeriodId: string
}

const getUserAvailableExpenseTypes = (filter: ExpenseTypeFilter): Promise<PagedExpenses> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'name',
    orderDescending: false,
  }

  return adminHttpClient.get('/Expenses/UserAvailableExpenseTypes', filter)
}

export default getUserAvailableExpenseTypes
